// Input Component

import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const Input = ({
  label,
  type = 'text',
  placeholder = '',
  value,
  onChange,
  error = '',
  disabled = false,
  required = false,
  name,
  id,
  className = '',
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const isNumber = type === 'number';
  const inputType = isPassword && showPassword ? 'text' : type;

  // Number inputs change value on mouse-wheel scroll while focused
  // (e.g. 180000 → 179900 with step 100). Blur so the scroll goes
  // to the page instead of stepping the value.
  const handleWheel = (event) => {
    props.onWheel?.(event);
    if (isNumber) event.currentTarget.blur();
  };

  // Arrow up/down also steps the value — block it for the same reason.
  const handleKeyDown = (event) => {
    props.onKeyDown?.(event);
    if (isNumber && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) event.preventDefault();
  };

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={id || name} className="block text-sm font-semibold text-slate-700 mb-2">
          {label}
          {required && <span className="text-rose-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          type={inputType}
          id={id || name}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`w-full px-4 py-3 rounded-xl border text-slate-800 text-sm placeholder-slate-400 transition-all duration-200 focus:outline-none focus:ring-2 ${
            isPassword ? 'pr-11' : ''
          } ${
            error
              ? 'border-rose-400 bg-rose-50 focus:ring-rose-300 focus:border-rose-400'
              : 'border-slate-200 bg-white focus:ring-violet-300 focus:border-violet-400'
          } ${
            disabled ? 'bg-slate-50 cursor-not-allowed opacity-60' : ''
          } ${className}`}
          {...props}
          onWheel={handleWheel}
          onKeyDown={handleKeyDown}
        />
        {isPassword && (
          <button
            type="button"
            tabIndex={-1}
            onClick={() => setShowPassword((v) => !v)}
            disabled={disabled}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            className="absolute right-3 top-1/2 -translate-y-1/2 flex h-7 w-7 items-center justify-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors disabled:cursor-not-allowed disabled:opacity-60"
          >
            {showPassword ? <FiEyeOff className="h-4 w-4" /> : <FiEye className="h-4 w-4" />}
          </button>
        )}
      </div>
      {error && (
        <p className="text-rose-500 text-xs mt-1.5 font-medium">{error}</p>
      )}
    </div>
  );
};

export default Input;
